import { render, staticRenderFns } from "./ListsAdd.vue?vue&type=template&id=0c48f065&scoped=true&"
import script from "./ListsAdd.vue?vue&type=script&lang=js&"
export * from "./ListsAdd.vue?vue&type=script&lang=js&"
import style0 from "./ListsAdd.vue?vue&type=style&index=0&id=0c48f065&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c48f065",
  null
  
)

export default component.exports